import { render } from "./LinkBundleModal.vue?vue&type=template&id=0b9cb9a8"
import script from "./LinkBundleModal.vue?vue&type=script&lang=js"
export * from "./LinkBundleModal.vue?vue&type=script&lang=js"

import "./LinkBundleModal.vue?vue&type=style&index=0&id=0b9cb9a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__